import { useEffect, useRef } from "react";

const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Análise do Seu Caso",
    desc: "Conversamos com você para entender sua situação, histórico de trabalho e documentos disponíveis. Tudo de forma simples e sem julgamentos.",
  },
  {
    number: "02",
    icon: "ri-file-list-3-line",
    title: "Orientação dos Documentos",
    desc: "Indicamos exatamente quais documentos você precisa reunir, de forma clara e objetiva. Sem complicação, sem burocracia desnecessária.",
  },
  {
    number: "03",
    icon: "ri-send-plane-line",
    title: "Entrada no Pedido",
    desc: "Cuidamos de toda a parte burocrática: protocolo, petições e acompanhamento junto ao INSS. Você não precisa se preocupar com nada.",
  },
  {
    number: "04",
    icon: "ri-checkbox-circle-line",
    title: "Acompanhamento até a Aprovação",
    desc: "Ficamos ao seu lado em todas as etapas, desde a análise até a aprovação do benefício. Seu sucesso é o nosso objetivo.",
  },
];

export default function ComoFuncionaSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = "1";
            (entry.target as HTMLElement).style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll(".reveal-como");
    elements?.forEach((el, i) => {
      (el as HTMLElement).style.opacity = "0";
      (el as HTMLElement).style.transform = "translateY(30px)";
      (el as HTMLElement).style.transition = `opacity 0.6s ease ${i * 0.15}s, transform 0.6s ease ${i * 0.15}s`;
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="como-funciona"
      ref={sectionRef}
      className="py-20 md:py-28"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="reveal-como text-center mb-16">
          <span
            className="inline-block text-sm font-semibold tracking-widest uppercase mb-3"
            style={{ fontFamily: "Montserrat, sans-serif", color: "#0B4D6F" }}
          >
            Processo Simples
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ fontFamily: "Cinzel, serif", color: "#1A1A1A" }}
          >
            Como Funciona
          </h2>
          <div className="mx-auto mb-4" style={{ width: "60px", height: "3px", backgroundColor: "#0B4D6F", borderRadius: "2px" }} />
          <p
            className="text-base md:text-lg max-w-xl mx-auto"
            style={{ fontFamily: "Montserrat, sans-serif", color: "#666" }}
          >
            Em 4 passos simples, cuidamos de tudo para você conquistar seu benefício
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Vertical line (desktop) */}
          <div
            className="hidden md:block absolute left-[39px] top-10 bottom-10"
            style={{ width: "2px", backgroundColor: "#E2EEF4", zIndex: 0 }}
          />

          <div className="flex flex-col gap-10">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className="reveal-como flex flex-col sm:flex-row items-center sm:items-start gap-6 relative z-10"
              >
                {/* Number circle */}
                <div
                  className="flex-shrink-0 w-20 h-20 rounded-full flex items-center justify-center mx-auto sm:mx-0"
                  style={{ backgroundColor: "#0B4D6F" }}
                >
                  <span
                    className="text-2xl font-bold text-white"
                    style={{ fontFamily: "Cinzel, serif" }}
                  >
                    {step.number}
                  </span>
                </div>

                {/* Content */}
                <div
                  className="flex-1 rounded-2xl p-6 sm:p-8"
                  style={{ backgroundColor: "#F5F5F5" }}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: "#EBF4F8" }}
                    >
                      <i className={`${step.icon} text-lg`} style={{ color: "#0B4D6F" }}></i>
                    </div>
                    <h3
                      className="text-xl font-semibold"
                      style={{ fontFamily: "Cinzel, serif", color: "#1A1A1A" }}
                    >
                      {step.title}
                    </h3>
                  </div>
                  <p
                    className="text-base leading-relaxed"
                    style={{ fontFamily: "Montserrat, sans-serif", color: "#555" }}
                  >
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA inline */}
        <div className="reveal-como text-center mt-14">
          <p
            className="text-base mb-5"
            style={{ fontFamily: "Montserrat, sans-serif", color: "#666" }}
          >
            Pronto para começar? É simples e sem compromisso.
          </p>
          <a
            href="https://wa.me/5598992018216?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20meus%20direitos%20previdenci%C3%A1rios."
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-white font-semibold text-base whitespace-nowrap cursor-pointer transition-all duration-300 hover:opacity-90"
            style={{
              backgroundColor: "#0B4D6F",
              fontFamily: "Montserrat, sans-serif",
              boxShadow: "0 4px 20px rgba(11,77,111,0.25)",
            }}
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Iniciar Análise Gratuita
          </a>
        </div>
      </div>
    </section>
  );
}
